import Route from "@ember/routing/route"

export function initialize(_instance) {
  /**
   * I'm ovwriting this function so we can only show the full route -- e.g.
   * I want "planbook-show-class-settings" instead of
   * "planbook show class-settings planbook-show-class-settings"
   */

  Route.reopen({
    classNames: [],
    bodyClasses: Object.freeze([]),

    _getRouteDepthClasses() {
      let routeParts = this.routeName.split(".")

      return [routeParts.join("-")]
    },
  })
}

export default {
  name: "body-class-overwrite",
  initialize: initialize,
  after: ["body-class"],
}
